import React from "react";
import { LimitedTextField, Selector, IconComponent, SearchListContent, icon } from "../../../../common/components";
import { translate } from "../../../../common/providers";
import CategoriesTreeView from "../categories-view/CategoriesTreeView";
import styles from "./DeliverableSidePanel.module.css";

export default function FormView({
	payload,
	errors,
	isRefDuplicate,
	isNameDuplicate,
	types,
	formats,
	owners,
	phases,
	fbs,
	document,
	mode,
	isCategoriesOpen,
	onChangeName,
	onChangeMandatoryFields,
	onChangeNullableFields,
	onCheckCategory,
	onEditModeCategories,
	onExpand,
	onToggleCategories,
}) {
	return (
		<div className={styles.contentInner}>
			<div className={styles.formGrid}>
				<div className={styles.formCell}>
					<span className={styles.fieldLabel}>
						{translate("deliverables-list.document-dialog.doc-name")}
						<span className={styles.required}>*</span>
					</span>
					<LimitedTextField
						fullWidth
						className={styles.nameField}
						error={errors.name || isNameDuplicate}
						placeholder={translate("deliverables-list.document-dialog.doc-name-placeholder")}
						showCounter={false}
						showHelper={false}
						size="medium"
						value={payload.name || ""}
						onChange={onChangeName}
					/>
					{isNameDuplicate && (
						<div className={styles.duplicateWarning}>
							{translate("deliverables-list.error.duplicate_name")}
						</div>
					)}
				</div>
				<div className={styles.formCell}>
					<span className={styles.fieldLabel}>
						{translate("deliverables-list.document-dialog.type")} <span className={styles.required}>*</span>
					</span>
					<Selector
						fullWidth
						error={errors.type}
						items={types}
						placeholder={translate("deliverables-list.document-dialog.type-select")}
						size="small"
						value={payload.type || ""}
						valueRenderer={(option) => (typeof option === "string" ? option : option?.label || "")}
						onChange={(e) =>
							onChangeMandatoryFields(typeof e.target.value === "string" ? e.target.value : "", "type")
						}
					/>
				</div>
				<div className={styles.formCell}>
					<span className={styles.fieldLabel}>
						{translate("deliverables-list.document-dialog.format")}
						<span className={styles.required}>*</span>
					</span>
					<Selector
						fullWidth
						error={errors.format}
						items={formats}
						placeholder={translate("deliverables-list.document-dialog.format-select")}
						size="small"
						value={payload.format || ""}
						valueRenderer={(option) => (typeof option === "string" ? option : option?.label || "")}
						onChange={(e) =>
							onChangeMandatoryFields(typeof e.target.value === "string" ? e.target.value : "", "format")
						}
					/>
				</div>
				<div className={styles.formCell}>
					<span className={styles.fieldLabel}>
						{translate("deliverables-list.document-dialog.ref-id")}
						<span className={styles.required}>*</span>
					</span>
					<LimitedTextField
						fullWidth
						error={errors.ref || isRefDuplicate}
						placeholder={translate("deliverables-list.document-dialog.ref-id-placeholder")}
						showCounter={false}
						showHelper={false}
						size="medium"
						value={payload.ref || ""}
						onChange={(v) => onChangeMandatoryFields(v, "ref")}
					/>
					{isRefDuplicate && (
						<div className={styles.duplicateWarning}>
							{translate("deliverables-list.error.duplicate_ref")}
						</div>
					)}
				</div>
				<div className={styles.formCell}>
					<span className={styles.fieldLabel}>
						{translate("deliverables-list.document-dialog.owner")}
						<span className={styles.required}>*</span>
					</span>
					<Selector
						fullWidth
						error={errors.owner}
						fallbackField="email"
						field="displayName"
						items={owners}
						placeholder={translate("deliverables-list.document-dialog.owner-select")}
						size="small"
						value={payload.ownerId || ""}
						valueRenderer={(ownerId) => {
							const owner = owners.find((o) => o.id === ownerId);
							if (!owner) {
								return "";
							}
							return owner.displayName || owner.email || "";
						}}
						onChange={(e) =>
							onChangeMandatoryFields((e.target.value && e.target.value.id) || "", "ownerId")
						}
					/>
				</div>
				<div className={`${styles.formCell} ${styles.fullRow}`}>
					<span className={styles.fieldLabel}>
						{translate("deliverables-list.document-dialog.phase")}
						<span className={styles.required}>*</span>
					</span>
					<Selector
						fullWidth
						error={errors.phaseId}
						field="name"
						items={phases}
						placeholder={translate("deliverables-list.document-dialog.phase-select")}
						size="small"
						value={payload.phaseId || ""}
						valueRenderer={(phaseId) => phases.find((p) => p.id === phaseId)?.name || ""}
						onChange={(e) => onChangeNullableFields((e.target.value && e.target.value.id) || "", "phaseId")}
					/>
				</div>
			</div>
			<button className={styles.expandableHeader} type="button" onClick={onToggleCategories}>
				<div className={styles.categoriesTitle}>
					{translate("deliverables-list.document-dialog.categories")}
				</div>
				<IconComponent icon={isCategoriesOpen ? icon.faChevronUp : icon.faChevronDown} />
			</button>
			{isCategoriesOpen && (
				<div className={styles.categoriesContent}>
					{mode === "add" && (
						<SearchListContent
							isTree
							initChecked={(document?.thematics && document.thematics.map((c) => c.id)) || []}
							rowKey="id"
							rowLabelKey="name"
							rows={fbs}
							rowTooltipKey="name"
							subRowCounter="childrenCount"
							subRowKey="subThematic"
							onClickRow={onCheckCategory}
							onExpand={onExpand}
						/>
					)}
					{mode === "edit" && document?.id && (
						<CategoriesTreeView deliverableId={document?.id} onCategoriesChange={onEditModeCategories} />
					)}
				</div>
			)}
		</div>
	);
}
